import { API } from "aws-amplify";
import React, { useState } from "react";
import { Alert, Button, Platform, StyleSheet, Text, View } from "react-native";
import { TouchableOpacity } from "react-native-gesture-handler";
import Ionicons from "react-native-vector-icons/Ionicons";
import { createReviews, updateReviews } from "../../src/graphql/mutations";
import { globalStyles } from "../../styles/globalStyles";

export default function StarRatings({
  disabledRating,
  reviews,
  reviewer,
  bookId,
  refresh,
}) {
  let originalRating = 0.0;
  let numOfReviews;
  let defaultFav = false;

  if (typeof reviews != "undefined") {
    numOfReviews = reviews.length;
    // if (reviews != null) {
    reviews.map((item) => {
      if (item.rating != null) {
        originalRating += item.rating;
      } else numOfReviews--;

      if (item.reviewer.userName == reviewer.userName && item.favorite != null)
        defaultFav = item.favorite;
    });
  }
  originalRating = (originalRating / numOfReviews).toFixed(2);
  const [defaultRating, setDefaultRating] = useState(originalRating);
  const [favorite, setFavorite] = useState(defaultFav);
  const ratingNumbers = [1, 2, 3, 4, 5];

  // if a review already exists (through a comment) then just add the rating to that review
  // -- calls changeReview
  // if a review DOES NOT already exist (made no comments) then create a new review
  // if there is a comment with an existing review, then the user can't review again
  async function rateHandler() {
    let existingRating = false;
    let existingReview = false;
    let existingReviewId;
    if (typeof reviews != "undefined")
      reviews.map((review) => {
        if (review.reviewer.uId == reviewer.uId) {
          if (review.rating != null) {
            existingRating = true;
          } else {
            existingReview = true;
            existingReviewId = review.id;
          }
        }
      });
    if (existingRating) {
      if (Platform.OS == "web")
        window.confirm("You have already rated this book!");
      Alert.alert("You have already rated this book!");
    } else {
      if (existingReview) changeReview(existingReviewId);
      else await newReview();
      if (Platform.web == "web")
        window.confirm("your rating has been submitted!");
      Alert.alert("Your rating has been submitted!");
    }
    refresh(true);
  }

  async function favoriteHandler() {
    let existingReview = false;
    let existingReviewId;
    if (typeof reviews != "undefined")
      reviews.map((review) => {
        if (review.reviewer.userName == reviewer.userName) {
          existingReview = true;
          existingReviewId = review.id;
        }
      });
    if (existingReview) {
      changeFavorite(existingReviewId);
    } else {
      await newFavorite();
    }
    refresh(false);
  }

  async function changeReview(reviewId) {
    try {
      await API.graphql({
        query: updateReviews,
        variables: {
          input: {
            id: reviewId,
            rating: defaultRating,
            profilePicture: reviewer.profilePicture,
          },
        },
      });
    } catch (evt) {
      console.log(evt);
    }
  }

  // find a better way -- favorite does not update automatically after state change
  // always marked as false
  async function changeFavorite(reviewId) {
    try {
      await API.graphql({
        query: updateReviews,
        variables: {
          input: {
            id: reviewId,
            favorite: !favorite,
            profilePicture: reviewer.profilePicture,
          },
        },
      });
    } catch (evt) {
      console.log(evt);
    }
  }

  async function newReview() {
    try {
      await API.graphql({
        query: createReviews,
        variables: {
          input: {
            reviewsReviewerUId: reviewer.uId,
            rating: defaultRating,
            booksReviewsBookId: bookId,
            profilePicture: reviewer.profilePicture,
          },
        },
      });
    } catch (evt) {
      console.log(evt);
    }
  }

  async function newFavorite() {
    try {
      await API.graphql({
        query: createReviews,
        variables: {
          input: {
            reviewsReviewerUId: reviewer.uId,
            favorite: !favorite,
            booksReviewsBookId: bookId,
            profilePicture: reviewer.profilePicture,
          },
        },
      });
    } catch (evt) {
      console.log(evt);
    }
  }
  return (
    <View style={{ alignItems: "center" }}>
      <View
        style={
          Platform.OS == "web"
            ? { ...styles.backgroundStyle, width: 500 }
            : styles.backgroundStyle
        }
      >
        <TouchableOpacity
          onPress={async () => {
            setFavorite(!favorite);
            if (favorite) {
              if (Platform.OS == "web")
                window.confirm("removed from your recommendations.");
              Alert.alert("Removed from your recommendations.");
            } else {
              if (Platform.OS == "web")
                window.confirm("Added to your recommendations!");
              Alert.alert("Added to your recommendations!");
            }
            await favoriteHandler();
          }}
        >
          {favorite ? (
            <Ionicons name="heart" size={30} color={"#f09797"} />
          ) : (
            <Ionicons name="heart-outline" size={30} color={"#f09797"} />
          )}
        </TouchableOpacity>
        <Text
          style={{
            color: "white",
            fontFamily: "quicksand-bold",
            marginTop: 2,
            fontSize: 20,
            marginHorizontal: 10,
          }}
        >
          {originalRating}
        </Text>
        {ratingNumbers.map((item) => {
          return (
            <TouchableOpacity
              key={item}
              onPress={() => {
                setDefaultRating(item);
              }}
              style={{ marginHorizontal: 2 }}
              disabled={disabledRating}
            >
              {item <= defaultRating ? (
                <Ionicons name="star" size={26} color={"#ffb861"} />
              ) : (
                <Ionicons name="star-outline" size={26} color={"#ffb861"} />
              )}
            </TouchableOpacity>
          );
        })}
        {!disabledRating && (
          <TouchableOpacity
            onPress={async () => {
              await rateHandler();
            }}
            // style={{ borderRadius: 10, backgroundColor: "black" }}
          >
            <Text
              style={{
                color: "white",
                fontFamily: "quicksand-bold",
                marginTop: 5,
                fontSize: 18,
                marginHorizontal: 5,
              }}
            >
              RATE
            </Text>
          </TouchableOpacity>
        )}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  backgroundStyle: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    height: 100,
    paddingVertical: 20,
    backgroundColor: "#6e4732",
    marginHorizontal: 20,
    borderRadius: 15,
    opacity: 0.6,
    marginTop: 10,
    width: "90%",
    height: 70,
  },
});
